<template>
  <canvas class="canvas" ref="myCanvas" />
</template>

<script>
import all_loops from "../assets/loops.json";
import * as THREE from "three";
let meshScale = 1 / 200.0;
var halfWidth = 0.25;
var bgColor = "#8FD1DF";

let scene, camera, renderer;

const vertexShader = `
uniform float time;
uniform float rotX;
uniform float rotY;
void main () {
  vec4 positionNew = modelMatrix * vec4(position, 1.0);
  positionNew.z -= 18.0;
  float xScale = (rotX - 3.1415926 / 20.0) * 6.0 / 3.1415926;
  float yScale = rotY * 6.0 / 3.1415926;
  positionNew.z += max(abs(xScale * 19.0), abs(yScale * 19.0));
  if (positionNew.z < 0.0){
    if (position.x > 0.0){
      // positionNew.x = length(positionNew) - positionNew.z * 1.5;
      positionNew.x = 3000.0;
    }else{
      // positionNew.x = -length(positionNew) - positionNew.z * positionNew.z;
      positionNew.x = -3000.0;
    }
    positionNew.z = -0.05;
  }else{
    // // here we add wiggle effect
    positionNew.y += sin(time / 2.0 + position.x / 3.0 + position.y / 2.0  - position.z / 3.0) / 12.0;
    positionNew.y += sin(-time / 2.0 + position.x / 7.0 - position.y / 7.0  + position.z / 7.0) / 12.0;
    positionNew.y += sin(-time / 2.0 + position.x / 5.0 + position.y / 5.0  + position.z / 5.0) / 12.0;
    positionNew.y += sin(time / 2.0 + position.x / 2.0 - position.y / 2.0  - position.z / 2.0) / 12.0;
  }
  
  gl_Position = projectionMatrix * viewMatrix * positionNew;
}
`;

const fragmentShader = `
  void main() {
      gl_FragColor = vec4(239.0 / 255.0, 240.0 / 255.0, 222.0 / 255.0, 1.0);
  }
`;
var clock = new THREE.Clock();

const lineMaterial = new THREE.ShaderMaterial({
  vertexShader: vertexShader,
  fragmentShader: fragmentShader,
  side: THREE.DoubleSide,
  uniforms: {
    time: { value: clock.getElapsedTime() },
    rotX: { value: 0.0 },
    rotY: { value: 0.0 },
  },
});

scene = new THREE.Scene();
camera = new THREE.PerspectiveCamera(
  15,
  window.innerWidth / window.innerHeight,
  10,
  200
);
camera.position.set(0, 0, 100);
camera.lookAt(scene.position);

export default {
  name: "lines",
  data() {
    return {
      loopsThreeRaw: [],
      loopsThreeRotated: [],
      loopsConverted: [],
      lineMeshes: [],
      mouseXNormalized: 0,
      mouseYNormalized: 0,
      mouseXLerped: 0,
      mouseYLerped: 0,
    };
  },
  methods: {
    convertToThreeVector(loopRaw) {
      let loop = [];
      for (let j = 0; j < loopRaw.length; j += 1) {
        let z = loopRaw[j][2] * meshScale;
        let y = loopRaw[j][1] * meshScale;
        let x = loopRaw[j][0] * meshScale;
        loop.push(new THREE.Vector3(x, y, z));
      }

      // we need to break it into two parts
      // because we want one part of back to go to left
      // and other part to go to right
      let breakIndex = 0;
      for (let j = 0; j < loop.length - 1; j++) {
        if (loop[j + 1].x * loop[j].x < 0 && loop[j].z < 0) {
          breakIndex = j + 1;
          break;
        }
      }
      let loopRotated = [];
      for (let j = breakIndex; j < loop.length; j++) {
        loopRotated.push(loop[j]);
      }
      for (let j = 0; j < breakIndex; j++) {
        loopRotated.push(loop[j]);
      }
      // make sure the order is the same
      if (loopRotated[0].x > loopRotated[loopRotated.length - 1].x) {
        loopRotated.reverse();
      }
      return loopRotated;
    },
    rotateAroundXY(xRot, yRot) {
      for (let i = 0; i < this.lineMeshes.length; i++) {
        this.lineMeshes[i].rotation.x = xRot;
        this.lineMeshes[i].rotation.y = yRot;
      }
      lineMaterial.uniforms.rotX.value = xRot;
      lineMaterial.uniforms.rotY.value = yRot;
    },

    mouseMove(event) {
      // The browser's coordinate system has (0,0) at the top-left
      // and (window.innerWidth, window.innerHeight) at the bottom-right.

      // Normalize the mouse coordinates from -1 to 1
      this.mouseXNormalized = (event.clientX / window.innerWidth) * 2 - 1;
      this.mouseYNormalized = -(event.clientY / window.innerHeight) * 2 + 1; // Note the negative as the screen's y-coordinate goes from top to bottom.
    },

    touchMove(event) {
      // Prevent the default scrolling on touch move
      event.preventDefault();

      // The event.touches is a list of all current touch points.
      // For simplicity, we're only considering the first touch point.
      const touch = event.touches[0];

      // Normalize the touch coordinates from -1 to 1
      this.mouseXNormalized = (touch.clientX / window.innerWidth) * 2 - 1;
      this.mouseYNormalized = -(touch.clientY / window.innerHeight) * 2 + 1; // Negative because the screen's y-coordinate goes from top to bottom.
    },

    preProcessLoops() {
      // we first need to clean the loops
      let newLoops = [];
      let lastHeight = all_loops[0][0][1];
      let currentHeightLargestLength = all_loops[0].length;
      let currentHeightPickedIndex = 0;
      for (let i = 1; i < all_loops.length; i++) {
        if (all_loops[i][0][1] != lastHeight) {
          // first we push the largest loop of the last height
          // and make it threejs vectors
          newLoops.push(
            this.convertToThreeVector(all_loops[currentHeightPickedIndex])
          );
          // this is a new height
          lastHeight = all_loops[i][0][1];
          currentHeightLargestLength = all_loops[i].length;
          currentHeightPickedIndex = i;
        } else {
          // this is the same height
          if (all_loops[i].length > currentHeightLargestLength) {
            currentHeightLargestLength = all_loops[i].length;
            currentHeightPickedIndex = i;
          }
        }
      }
      // push the last one
      newLoops.push(
        this.convertToThreeVector(all_loops[currentHeightPickedIndex])
      );

      for (let i = 0; i < newLoops.length; i++) {
        this.loopsThreeRaw.push(newLoops[i]);
      }
    },
    async init() {
      // define the renderer first
      renderer = new THREE.WebGLRenderer({
        canvas: this.$refs.myCanvas,
        antialias: true,
        powerPreference: "high-performance",
      });
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.setSize(window.innerWidth, window.innerHeight);
      renderer.setClearColor(bgColor, 1);

      // add those lines to the scene
      // let's create the actual line segments

      for (let i = 0; i < this.loopsThreeRaw.length; i++) {
        const geometry = new THREE.BufferGeometry();
        var positions = [];
        for (let j = 0; j < this.loopsThreeRaw[i].length - 1; j++) {
          // ok create two triangle segments
          // top left
          var topLeft = this.loopsThreeRaw[i][j].clone();
          topLeft.y += halfWidth;
          // bottom left
          var botLeft = this.loopsThreeRaw[i][j].clone();
          botLeft.y -= halfWidth;
          // top right
          var topRight = this.loopsThreeRaw[i][j + 1].clone();
          topRight.y += halfWidth;
          // bottom right
          var botRight = this.loopsThreeRaw[i][j + 1].clone();
          botRight.y -= halfWidth;
          // ok push the positions
          positions.push(topLeft.x, topLeft.y, topLeft.z);
          positions.push(botLeft.x, botLeft.y, botLeft.z);
          positions.push(topRight.x, topRight.y, topRight.z);
          positions.push(botLeft.x, botLeft.y, botLeft.z);
          positions.push(botRight.x, botRight.y, botRight.z);
          positions.push(topRight.x, topRight.y, topRight.z);
        }
        geometry.setAttribute(
          "position",
          new THREE.Float32BufferAttribute(positions, 3)
        );
        geometry.computeVertexNormals();
        const line = new THREE.Mesh(geometry, lineMaterial);
        this.lineMeshes.push(line);
        scene.add(line);
      }

      window.addEventListener("resize", this.onWindowResize);
      window.addEventListener("mousemove", this.mouseMove);
      window.addEventListener("touchmove", this.touchMove, { passive: false });
    },
    lerp(start, end, amt) {
      return (1 - amt) * start + amt * end;
    },
    animate() {
      let me = this;
      setTimeout(() => {
        lineMaterial.uniforms.time.value = clock.getElapsedTime();
        this.mouseXLerped = this.lerp(
          this.mouseXLerped,
          this.mouseXNormalized,
          0.07
        );
        this.mouseYLerped = this.lerp(
          this.mouseYLerped,
          this.mouseYNormalized,
          0.07
        );
        this.rotateAroundXY(
          (-Math.PI / 6.0) * this.mouseYLerped + Math.PI / 20.0,
          (Math.PI / 6.0) * this.mouseXLerped
        );
        requestAnimationFrame(me.animate);
      }, 1000 / 60);
      this.render();
    },

    render() {
      renderer.render(scene, camera);
    },
    onWindowResize() {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    },
  },
  async mounted() {
    this.preProcessLoops();
    this.init();
    this.animate();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
canvas {
  width: 100vw;
  height: 100vh;
  background-color: black;
}
</style>
